import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Alert, Spinner, Row, Col, Button, ProgressBar } from 'react-bootstrap';
import { LanguageProvider } from '../../core/language-provider';
import { DataManager } from '../../core/data-manager';
import { Helmet } from 'react-helmet';
import Episode from '../../components/Episode';
import { settings } from '../../config/settings';
import { LoginManager } from '../../core/login-manager';
import { ApiManager } from '../../core/api-manager';
import moment from 'moment';



export default function EpisodeDetail() {

    const navigate = useNavigate();
    const [errors, setErrors] = useState('');
    const { k } = useParams();
    const id = parseInt(k)

    const [data, setData] = useState(null);
    const [idSession, setIdSession] = useState(null);
    const [intervalSeconds, setIntervalSeconds] = useState(5);
    const [crono, setCrono] = useState(0);
    const userInfo = LoginManager.getUserInfo();


    useEffect(() => {
        init()
    }, [id]);

    useEffect(() => {
        if (data) {
            getUserStats()
        }
    }, [data]);


    async function init() {
        var response = await DataManager.getItem('episode', id)
        if (response.success === 1) {
            if (response.body.length) {
                var t = response.body[0]
                console.warn('episodio', t)
                setData(t)
            }
            else {
                setErrors(LanguageProvider.get('errors.get'))
                console.warn(response)
                setData({})
            }
        }
        else {
            setErrors(LanguageProvider.get('errors.get'))
            console.warn(response)
        }
    }


    const [episodesStats, setEpisodesStats] = useState(null);
    async function getUserStats() {
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var constraints = [
            {
                "fieldName": "idEpisode",
                "type": "value",
                "value": data.id
            },
            {
                "fieldName": "author",
                "type": "value",
                "value": userInfo.id
            }
        ]
        var response = await DataManager.searchItems('episode_user', 1, 1, sorting, '', [], constraints)
        if (response.success === 1 && response.body.length > 0) {
            setEpisodesStats(response.body[0])
        }
        else {
            console.warn(response)
        }
    }

    useEffect(() => {
        const interval = setInterval(() => {
            setCrono(crono => crono + intervalSeconds);
        }, (intervalSeconds * 1000));

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (crono !== 0) {
            //if(data && data.type && data.type.value !== "live") {
            // per le live non salvo il tempo, verrà caricato file excel da zoom
            saveEpisodeTime()
            //}
        }
    }, [crono]);

    async function saveEpisodeTime() {
        if (id) {
            if (data.type?.value !== 'live') {
                const now = new Date();
                const episodeDate = new Date(data.episodeDate)

                if (now > episodeDate) {

                    console.warn('idSession', idSession)
                    if (idSession) {
                        console.warn('idSession trovato')
                        var body = {
                            idEpisodeUser: null,
                            dateStart: null,
                            dateEnd: moment().format('YYYY-MM-DD HH:mm:ss'),
                            idSession: parseInt(idSession),
                            device: null,
                            userAgent: null,
                            type: null
                        }
                        var res = await ApiManager.sendAuthenticatedRequest('/custom/create_record_session', body);
                        if (res.success === 1) {
                            console.log("Aggiornato con successo!", res)
                        } else {
                            console.log("UPDATE -- Errore!", res)
                        }
                    } else {
                        console.warn('idSession NON trovato')
                        if (episodesStats) {
                            var body = {
                                idSession: null,
                                idEpisodeUser: episodesStats.id,
                                dateStart: moment().format('YYYY-MM-DD HH:mm:ss'),
                                dateEnd: moment().format('YYYY-MM-DD HH:mm:ss'),
                                type: data && data.type.value === "video" ? "10_VIDEO" : data && data.type.value === "live" ? "0_LIVE" : data && data.type.value === "survey" ? "20_SURVEY" : data && data.type.value === "file" ? "30_FILE" : null,
                                device: window.innerWidth < 768 ? "0_MOBILE" : "10_DESKTOP",
                                userAgent: window.navigator.userAgent
                            }
                            var res = await ApiManager.sendAuthenticatedRequest('/custom/create_record_session', body);
                            if (res.success === 1) {
                                console.log("Inserito con successo!", res)
                                setIdSession(parseInt(res.id))
                            } else {
                                console.log("INSERT -- Errore!", res)
                            }
                        }
                    }

                    console.warn('Controllo episodeStats')
                    if (episodesStats) {
                        console.warn('episodeStats - trovato')

                        console.warn('episodesStats', episodesStats, 'data', data)
                        // aggiorno episode user
                        if (data.percentage) {
                            var totalTime = data.estimatedMinutes * 60 * data.percentage / 100
                        }
                        else {
                            var totalTime = data.estimatedMinutes * 60
                        }

                        if (totalTime < episodesStats.time + intervalSeconds) {
                            var responseUser = await LoginManager.updateProfile({ points: data.points });
                            var body = {
                                'time': episodesStats.time + intervalSeconds,
                                'isCompleted': 1
                            }
                        }
                        else {
                            var body = {
                                'time': episodesStats.time + intervalSeconds
                            }
                        }

                        var response = await DataManager.updateItem('episode_user', body, episodesStats.id);
                        if (response.success === 1) {
                            getUserStats()
                        }

                    }
                    else {
                        console.warn('episodeStats - NON trovato')
                        var body = {
                            'idEpisode': id,
                            'idCourse': data.idCourse.id,
                            'time': intervalSeconds
                        }
                        var response = await DataManager.insertItem('episode_user', body);
                        if (response.success === 1) {
                            console.log(response)
                            getUserStats()
                        }
                    }
                }
            }
        }
    }



    if (data) {
        if (data.name) {

            return (
                <>
                    <Helmet>
                        <title>{data.name}</title>
                    </Helmet>

                    <Container fluid style={{ backgroundColor: 'var(--primary-color)' }} className='p-0'>
                        <div className=''>
                            <Container fluid='md' className=' mb-5 text-light py-5'>

                                {errors.length > 0 &&
                                    <Alert variant='danger'>
                                        {errors}
                                    </Alert>
                                }
                                <Button style={{ border: 0, color: 'white', backgroundColor: 'transparent' }} className='mb-5' onClick={() => navigate('/corsi/' + data.idCourse?.id)}><FontAwesomeIcon icon='arrow-left' className='me-2'></FontAwesomeIcon>{LanguageProvider.get('defaults.back')}</Button>
                                <h4>{data.idCourse.name}</h4>
                                <h2>{data.name}</h2>

                            </Container>
                        </div>
                    </Container>


                    <Episode course={data.idCourse} episode={data} />


                    <Container fluid='md' className='mt-5 mb-5'>
                        <Row className='justify-content-between'>
                            <Col md={4} xs={12}>
                                <Container className='p-3' style={{ backgroundColor: '#f7f7f7', borderRadius: '20px', color: 'var(--primary-color)' }}>
                                    <h5 className='mb-4'>Lista Materiali</h5>
                                    {data.documents && data.documents.map(item => {
                                        var file_url = settings.ckdPath + "/upload/episode_documents/" + item.file.hash + "." + item.file.extension
                                        return (
                                            <div key={item.id}>
                                                <a href={file_url} target="_blank">
                                                    <Button variant='light' style={{ borderRadius: '20px', borderColor: 'var(--primary-color)', color: 'var(--primary-color)' }} className='px-3 mb-2 w-100'>{item.name}<FontAwesomeIcon icon='download' className='ms-2'></FontAwesomeIcon></Button>
                                                </a>
                                            </div>

                                        )
                                    })}
                                </Container>
                            </Col>
                            <Col md={8} xs={12}>
                                <Container className='p-3' style={{ backgroundColor: '#f7f7f7', borderRadius: '20px', color: 'var(--primary-color)' }}>
                                    <h5 className='mb-4'>Informazioni Aggiuntive</h5>
                                    <div dangerouslySetInnerHTML={{ __html: data.description }}></div>
                                </Container>
                            </Col>
                        </Row>


                        {data && data.type && data.type.value !== "live" ? (
                            <Container className='p-3 mt-4' style={{ backgroundColor: '#f7f7f7', borderRadius: '20px', color: 'var(--primary-color)' }}>
                                <h5>Il tuo avanzamento</h5>
                                {episodesStats && episodesStats.isCompleted ? (
                                    <p>Episodio completato!</p>
                                ) : (
                                    <>
                                        <p>Completa l'episodio prima di proseguire.</p>
                                        <ProgressBar>
                                            <ProgressBar striped variant="primary" now={episodesStats ? episodesStats.time * 100 / (data.estimatedMinutes * 60) : 0} key={1} />
                                            {data.percentage ? (
                                                <ProgressBar now={data.percentage} label={''} key={2} style={{ borderRight: '1px solid #000', backgroundColor: 'transparent' }} />
                                            ) : null}
                                        </ProgressBar>
                                    </>
                                )}
                            </Container>
                        ) : null}


                    </Container>
                </>
            )
        }
        else {
            return (
                <>
                    <Helmet>
                        <title>Corso non trovato</title>
                    </Helmet>

                    <Container fluid='md' className='mt-5 mb-5 text-secondary'>
                        <h3>Corso non trovato</h3>

                        {errors.length > 0 &&
                            <Alert variant='danger'>
                                {errors}
                            </Alert>
                        }

                    </Container>
                </>
            )
        }
    }
    else {
        return (
            <Container fluid="md" className='mt-5 mb-5'>
                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="primary" />
                    <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                </div>
            </Container>
        )
    }
};